// TODO: [SCOPE B] 출고 상태 API 대체 예정
export const OUTBOUNDS_STATUS = [
  { label: '출고대기', value: 'WAIT' },
  { label: '가송장', value: 'INVOICE' },
  { label: '출고완료', value: 'COMPLETED' },
  { label: '부분출고', value: 'PARTIAL' },
  { label: '출고취소', value: 'CANCEL' },
  { label: '과출고', value: 'OVER' },
  { label: '미출고', value: 'UNSHIPPED' },
]

/** 글로벌 재고이관 상태 라벨 — 1.0 gi03 과 같은 라벨 (LOGISPRD-15579) */
export const GLOBAL_TRANSFER_STATUS_LABEL: Record<string, string> = {
  PENDING: '요청전',
  REQUESTED: '이관요청',
  IN_TRANSIT: '이동중',
  PARTIALLY_RECEIVED: '부분입고',
  COMPLETED: '이관완료',
  FAILED: '실패',
  HOLD: '보류',
  REALLOCATED: '재할당',
}

/** 모르는 값은 원문 그대로, 값이 없으면 빈칸 */
export const formatGlobalTransferStatus = (value?: string | null): string => {
  if (!value) return ''
  return GLOBAL_TRANSFER_STATUS_LABEL[value] ?? value
}
